import http from '../common/http-common'

// Respuestas del API
export interface ApiOk {
  mensaje: string; 
}
export interface ApiError {
  error: string;
}

class NotificacionesDataService {
  notificarRetardos(bloque: 'AM' | 'PM') {
    const url = `/Notificaciones/NotificarRetardos/${bloque}`; 
    return http.post<ApiOk>(url);
  }

  async notificarAmbos() {
    await this.notificarRetardos('AM');
    await this.notificarRetardos('PM');
  }


  notificarRetardosSemanalMTY() {
  const url = `/Notificaciones/NotificarRetardosSemanalMTY`;
  return http.post<ApiOk>(url);
}



}

export default new NotificacionesDataService();
